(() => {
  var trackedEvents = [
    'reference_cta_click',
    'reference_pdf_download',
    'reference_calendly_click',
    'reference_contact_success',
    'diy_project_cta_click',
    'landing_consultation_click',
    'landing_acheck_start',
    'landing_product_click',
    'landing_reference_click',
    'landing_photo_email_click',
    'landing_form_start',
    'landing_lead_submit',
    'landing_room_select',
    'landing_calc_start',
    'landing_calc_use',
    'landing_calc_cta',
    'landing_download_click',
    'landing_sample_click',
    'landing_tender_click',
    'header_cta_click',
  ];
  // Die Quellen-Handles standen hier frueher als drittes Duplikat neben den
  // Page-Metafeldern und dem case/when in templates/page.landing.liquid. Eine neue
  // Landingpage haette also auch hier gepflegt werden muessen, sonst faellt still
  // das Tracking aus. Jetzt kommen Handle und Typ vom ausloesenden Element selbst.

  function sessionGet(key) {
    try {
      return window.sessionStorage.getItem(key);
    } catch (_error) {
      return '';
    }
  }

  function sessionSet(key, value) {
    if (!value) return;
    try {
      window.sessionStorage.setItem(key, value);
    } catch (_error) {
      // Storage can be unavailable in strict privacy modes.
    }
  }

  // Nur für Marketing-Attribution (UTM, GCLID, Kampagnenquelle) — schreibt erst
  // nach erteilter Einwilligung. Siehe Consent-Gate weiter unten.
  function sessionSetMarketing(key, value) {
    if (!value) return;
    if (trackingAllowed() !== true) return;
    sessionSet(key, value);
  }

  function sessionRemove(key) {
    try {
      window.sessionStorage.removeItem(key);
    } catch (_error) {
      // Storage can be unavailable in strict privacy modes.
    }
  }

  // ── Consent-Gate ──────────────────────────────────────────────────────────
  // Marketing-Attribution (UTM/GCLID im sessionStorage) und dataLayer-Pushes an
  // GTM sind NICHT "unbedingt erforderlich" i. S. d. § 25 Abs. 2 Nr. 2 TDDDG.
  // Vorher liefen beide ungated bei jedem Seitenaufruf. Jetzt hängen sie an
  // Shopifys Customer-Privacy-API; bis eine Entscheidung vorliegt, wird
  // gepuffert statt geschrieben. Funktionale Speicher (z. B. das Akustik-Ziel
  // in pdp-acheck) sind bewusst nicht betroffen.
  var pendingEvents = [];

  function consentApi() {
    return window.Shopify?.customerPrivacy;
  }

  function trackingAllowed() {
    var api = consentApi();
    if (!api) return null; // noch unbekannt
    try {
      return Boolean(api.analyticsProcessingAllowed() || api.marketingAllowed());
    } catch (_error) {
      return null;
    }
  }

  function writeEvent(payload) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);
  }

  function flushPending() {
    if (trackingAllowed() !== true) {
      pendingEvents = [];
      return;
    }
    var queued = pendingEvents;
    pendingEvents = [];
    queued.forEach(writeEvent);
  }

  document.addEventListener('visitorConsentCollected', flushPending);

  function pushEvent(eventName, contentHandle, destination, contentType) {
    if (trackedEvents.indexOf(eventName) === -1) return;
    var payload = {
      event: eventName,
      content_handle: contentHandle || 'unknown',
      content_type: contentType || 'unknown',
      project_handle: contentHandle || 'unknown',
      source_page: window.location.pathname,
      destination: destination || window.location.href,
    };
    var allowed = trackingAllowed();
    if (allowed === true) {
      writeEvent(payload);
      return;
    }
    // Banner noch nicht beantwortet: puffern, aber begrenzt.
    if (allowed === null && pendingEvents.length < 20) pendingEvents.push(payload);
  }

  window.FennextTracking = Object.freeze({ push: pushEvent });

  // Die Sektion #beratung-anfrage bedient mehrere Einstiege: Remote-Analyse, Vor-Ort-
  // Projekt und — aus Header und Footer — das Angebot. Ueberschrift, Vorspann und
  // Absende-Button wechseln dabei gemeinsam. Vorher wechselte nur die Ueberschrift:
  // ueber dem Formular stand "Remote-Analyse anfragen", auf dem Knopf darunter
  // "Kostenlose Ersteinschaetzung anfragen".
  function applyConsultationIntent(interest, heading, intro, submit) {
    var interestField = document.querySelector('[data-consultation-interest]');
    var headingElement = document.querySelector('[data-consultation-form-heading]');
    var introElement = document.querySelector('[data-consultation-form-intro]');
    var submitElement = document.querySelector('[data-consultation-form-submit]');
    if (interestField && interest) interestField.value = interest;
    if (headingElement && heading) headingElement.textContent = heading;
    if (introElement && intro) introElement.textContent = intro;
    if (submitElement && submit) submitElement.textContent = submit;
  }

  function initCollectionPage() {
    var page = document.querySelector('[data-collection-page]');
    if (!page) return;

    var drawer = page.querySelector('[data-facets-drawer]');
    var triggers = Array.from(page.querySelectorAll('[data-facets-open]'));
    var lastTrigger = null;

    function setTriggerState(expanded) {
      triggers.forEach((trigger) => {
        trigger.setAttribute('aria-expanded', String(expanded));
      });
    }

    function focusableElements() {
      if (!drawer) return [];
      return Array.from(
        drawer.querySelectorAll(
          'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), summary, [tabindex]:not([tabindex="-1"])',
        ),
      ).filter((element) => element.offsetParent !== null);
    }

    function openDrawer(trigger) {
      if (!drawer) return;
      lastTrigger = trigger;
      drawer.classList.add('open');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.classList.add('facets-open');
      setTriggerState(true);

      window.setTimeout(() => {
        var focusTarget = drawer.querySelector('[data-facets-close]');
        if (focusTarget) focusTarget.focus();
      }, 30);
    }

    function closeDrawer() {
      if (!drawer) return;
      drawer.classList.remove('open');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('facets-open');
      setTriggerState(false);
      if (lastTrigger) lastTrigger.focus();
    }

    triggers.forEach((trigger) => {
      trigger.addEventListener('click', () => openDrawer(trigger));
    });

    if (drawer) {
      drawer.querySelectorAll('[data-facets-close]').forEach((button) => {
        button.addEventListener('click', closeDrawer);
      });

      drawer.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          closeDrawer();
          return;
        }
        if (event.key !== 'Tab') return;

        var focusable = focusableElements();
        if (!focusable.length) return;
        var first = focusable[0];
        var last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      });
    }

    // Die Kategoriezeile scrollt auf dem Handy waagerecht (666px Inhalt in 355px). Bei den
    // hinteren Kategorien lag die aktive Markierung dadurch ausserhalb des Bildschirms —
    // der Kunde sah nicht, wo er ist. Sie wird an den rechten Rand geholt, nicht zentriert:
    // So bleiben die vorherigen Eintraege links angeschnitten und zeigen, dass die Zeile
    // weitergeht.
    var catswitch = page.querySelector('[data-catswitch]');
    var activeCategory = catswitch ? catswitch.querySelector('.catswitch__link--active') : null;
    var catswitchPadding = 16;
    var activeCategoryRight;
    if (activeCategory && catswitch.scrollWidth > catswitch.clientWidth) {
      activeCategoryRight = activeCategory.offsetLeft + activeCategory.offsetWidth;
      if (activeCategoryRight > catswitch.clientWidth - catswitchPadding) {
        catswitch.scrollLeft = activeCategoryRight - catswitch.clientWidth + catswitchPadding;
      }
    }

    var sort = page.querySelector('[data-collection-sort]');
    if (sort) {
      sort.addEventListener('change', () => {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', sort.value);
        url.searchParams.delete('page');
        window.location.assign(url.toString());
      });
    }
  }

  document.addEventListener('click', (event) => {
    var sourceType;
    var target = event.target.closest('[data-track]');
    if (!target) return;

    var contentHandle =
      target.getAttribute('data-content-handle') || target.getAttribute('data-project-handle');
    var trackingEvent = target.getAttribute('data-track');
    // Handle UND Typ mitgeben: Auf der Kontaktseite ist der ausloesende CTA nicht
    // mehr im DOM, der Typ laesst sich dort also nicht rekonstruieren.
    // Schreiben geht ueber sessionSetMarketing, also erst nach Einwilligung.
    // reference_cta_click gehoert mit in die Weiche: Die Referenz-CTAs
    // (sections/reference-case.liquid, templates/page.referenzen.liquid) tragen kein
    // data-content-type, und kein Element im Theme setzt den Wert "reference". Ohne
    // diesen Zweig bliebe fennext_contact_source_type leer, die Auswertung unten
    // fiele in den else-Zweig — jede Referenz-Anfrage waere als Landing-Lead
    // gezaehlt worden und reference_contact_success haette nie mehr gefeuert.
    if (
      (trackingEvent === 'landing_consultation_click' || trackingEvent === 'reference_cta_click') &&
      contentHandle
    ) {
      sourceType = trackingEvent === 'reference_cta_click' ? 'reference' : 'landing';
      sessionSetMarketing('fennext_contact_source', contentHandle);
      sessionSetMarketing(
        'fennext_contact_source_type',
        target.getAttribute('data-content-type') || sourceType,
      );
    }

    var serviceInterest = target.getAttribute('data-service-interest');
    if (serviceInterest) {
      applyConsultationIntent(
        serviceInterest,
        target.getAttribute('data-form-heading'),
        null,
        target.getAttribute('data-form-submit'),
      );
    }

    pushEvent(
      trackingEvent,
      contentHandle,
      target.href || target.getAttribute('data-destination'),
      target.getAttribute('data-content-type'),
    );
  });

  var startedLeadForms = {};
  document.addEventListener('focusin', (event) => {
    var leadForm = event.target.closest('[data-lead-form]');
    if (!leadForm) return;

    var contentHandle = leadForm.getAttribute('data-lead-form');
    if (startedLeadForms[contentHandle]) return;

    startedLeadForms[contentHandle] = true;
    sessionSetMarketing('fennext_contact_source', contentHandle);
    pushEvent('landing_form_start', contentHandle, 'shopify_contact_form', 'consultation');
  });

  document.addEventListener('DOMContentLoaded', () => {
    initCollectionPage();

    // Formular-Ergebnis nach dem Reload in den Fokus holen, damit Screenreader
    // und Tastaturnutzer die Rueckmeldung ueberhaupt erreichen.
    var announced = document.querySelector('[data-autofocus]');
    if (announced) announced.focus();

    var matchingArea;
    var parameters = new URLSearchParams(window.location.search);
    var attributionFields = [
      ['utm_source', 'fennext_utm_source', '[data-contact-utm-source]'],
      ['utm_campaign', 'fennext_utm_campaign', '[data-contact-utm-campaign]'],
      ['gclid', 'fennext_gclid', '[data-contact-gclid]'],
    ];

    attributionFields.forEach((field) => {
      var parameterValue = parameters.get(field[0]);
      if (parameterValue) sessionSetMarketing(field[1], parameterValue);
      var formField = document.querySelector(field[2]);
      if (formField) formField.value = parameterValue || sessionGet(field[1]);
    });

    var subjectMap = {
      angebot: 'Angebot & B2B',
      beratung: 'Akustikberatung',
      musterpaket: 'Musterpaket',
      versand: 'Bestellung & Versand',
    };
    var subject = subjectMap[parameters.get('betreff')];
    var subjectSelect = document.getElementById('contact-betreff');
    if (subject && subjectSelect) subjectSelect.value = subject;

    var area = parameters.get('bereich');
    var areaSelect = document.getElementById('contact-bereich');
    // Die Projektfelder stecken in einem zugeklappten <details>. Ohne das Aufklappen
    // sieht der Nutzer die Vorbelegung aus dem Landing-CTA nie und traegt den
    // Bereich ggf. doppelt in den Freitext ein.
    var areaDetails = areaSelect?.closest('details');
    if (area && areaSelect) {
      matchingArea = Array.from(areaSelect.options).some((option) => option.value === area);
      if (matchingArea) {
        areaSelect.value = area;
        if (areaDetails) areaDetails.open = true;
      }
    }

    // Header und Footer springen mit `?interesse=angebot` auf #beratung-anfrage. Die
    // Texte kommen aus den Datenattributen der Sektion (snippets/consultation-proof.liquid),
    // weil diese Datei ein statisches Asset ist und `| t` nicht aufloesen kann.
    var quoteSection = document.querySelector('[data-quote-heading]');
    if (quoteSection && parameters.get('interesse') === 'angebot') {
      applyConsultationIntent(
        quoteSection.getAttribute('data-quote-interest'),
        quoteSection.getAttribute('data-quote-heading'),
        quoteSection.getAttribute('data-quote-intro'),
        quoteSection.getAttribute('data-quote-submit'),
      );
    }

    // Telefonfeld haengt per CSS :has() am Rueckruf-Haken. Ohne JS-Kopplung sendet
    // "Rueckruf gewuenscht" ein leeres Telefonfeld ab und das Formular bestaetigt trotzdem.
    document.querySelectorAll('.consult-form__callback').forEach((group) => {
      var toggle = group.querySelector('.consult-form__check input[type="checkbox"]');
      var wrap = group.querySelector('.consult-form__phone');
      var field = wrap?.querySelector('input[type="tel"]');
      if (!toggle || !wrap || !field) return;
      var sync = () => {
        wrap.hidden = !toggle.checked;
        field.required = toggle.checked;
        field.setAttribute('aria-required', toggle.checked ? 'true' : 'false');
      };
      toggle.addEventListener('change', sync);
      sync();
    });

    var source = parameters.get('quelle');
    var sourceField = document.querySelector('[data-contact-source]');
    if (!source && sourceField) source = sourceField.value;
    // Formatpruefung statt gepflegter Whitelist: der Wert landet in einem Hidden
    // Field und darf nichts Beliebiges enthalten, muss aber nicht jede neue
    // Landingpage kennen.
    if (source && !/^[a-z0-9-]{3,80}$/.test(source)) source = '';
    if (source) sessionSetMarketing('fennext_contact_source', source);
    if (sourceField) sourceField.value = source || sessionGet('fennext_contact_source');

    var success = document.querySelector('[data-contact-success]');
    if (!success) return;

    var storedSource = source || sessionGet('fennext_contact_source');
    var storedType = sessionGet('fennext_contact_source_type');
    if (storedSource) {
      if (storedType === 'reference') {
        pushEvent('reference_contact_success', storedSource, 'shopify_contact_form', 'reference');
      } else {
        pushEvent('landing_lead_submit', storedSource, 'shopify_contact_form', 'landing');
      }
    }
    sessionRemove('fennext_contact_source');
    sessionRemove('fennext_contact_source_type');
  });
})();

/* Kundenbilder-Galerie auf der Referenzseite: Filterleiste und "mehr anzeigen".

   Fortschrittsverbesserung: Ohne JavaScript bleibt die vollstaendige Galerie
   sichtbar und Filterleiste wie Mehr-Button bleiben `hidden`. Das ist der richtige
   Ausfallzustand — lieber alles als nichts.

   Chips ohne Treffer werden entfernt statt ausgegraut. Ein Filter, der auf eine
   leere Galerie fuehrt, ist kein Angebot, sondern eine Sackgasse. Die Zaehlung
   passiert hier statt in Liquid, weil sie dort einen zweiten Durchlauf durch den
   gesamten Pool je Anwendung gekostet haette. */
(() => {
  var SICHTBAR_START = 12;

  document.addEventListener('DOMContentLoaded', () => {
    var galerie = document.querySelector('[data-usecase-gallery]');
    if (!galerie) return;

    var leiste = galerie.querySelector('[data-usecase-filter]');
    var raster = galerie.querySelector('[data-usecase-grid]');
    var leerHinweis = galerie.querySelector('[data-usecase-empty]');
    var mehrHuelle = galerie.querySelector('[data-usecase-more]');
    var mehrButton = galerie.querySelector('[data-usecase-more-button]');
    if (!leiste || !raster) return;

    var karten = Array.prototype.slice.call(raster.querySelectorAll('[data-usecase-tags]'));
    if (!karten.length) return;

    var chips = Array.prototype.slice.call(leiste.querySelectorAll('[data-usecase-value]'));
    var aktiv = 'alle';
    var alleZeigen = false;

    function passt(karte, wert) {
      if (wert === 'alle') return true;
      var tags = (karte.getAttribute('data-usecase-tags') || '').split(/\s+/);
      return tags.indexOf(wert) !== -1;
    }

    // Chips ohne Treffer entfernen, bevor die Leiste sichtbar wird.
    chips = chips.filter((chip) => {
      var wert = chip.getAttribute('data-usecase-value');
      if (wert === 'alle') return true;
      var treffer = karten.some((karte) => passt(karte, wert));
      if (!treffer) chip.remove();
      return treffer;
    });

    function zeichnen() {
      var gezeigt = 0;
      var passende = 0;
      karten.forEach((karte) => {
        if (!passt(karte, aktiv)) {
          karte.hidden = true;
          return;
        }
        passende += 1;
        var zuViel = !alleZeigen && gezeigt >= SICHTBAR_START;
        karte.hidden = zuViel;
        if (!zuViel) gezeigt += 1;
      });

      if (leerHinweis) leerHinweis.hidden = passende > 0;
      if (mehrHuelle) mehrHuelle.hidden = alleZeigen || passende <= SICHTBAR_START;
    }

    chips.forEach((chip) => {
      chip.addEventListener('click', () => {
        aktiv = chip.getAttribute('data-usecase-value');
        alleZeigen = false;
        chips.forEach((c) => {
          var an = c === chip;
          c.classList.toggle('is-active', an);
          c.setAttribute('aria-pressed', an ? 'true' : 'false');
        });
        zeichnen();
      });
    });

    if (mehrButton) {
      mehrButton.addEventListener('click', () => {
        alleZeigen = true;
        zeichnen();
      });
    }

    // Aus #anwendung-kita die Vorauswahl ableiten. So landen Besucher, die von
    // einer Anwendungsseite kommen, direkt im passenden Filter statt in der
    // Gesamtgalerie.
    //
    // Auch auf hashchange hoeren: Wer schon auf dieser Seite steht und einen
    // Ankerlink klickt, loest kein Neuladen aus — ohne diesen Zweig bliebe der
    // Filter stehen und der Sprung fuehrte ins Leere.
    function ausHashWaehlen() {
      var wert = (window.location.hash || '').replace('#anwendung-', '');
      if (!wert) return;
      var treffer = chips.filter((c) => c.getAttribute('data-usecase-value') === wert)[0];
      if (treffer) treffer.click();
    }
    window.addEventListener('hashchange', ausHashWaehlen);
    ausHashWaehlen();

    leiste.hidden = false;
    zeichnen();
  });
})();

/* Landingpages: Raum-Tabs, Ausstattungsbeispiel und Vorbelegung des Anfrageformulars.
   Bausteine aus dem Review vom 2026-09-16 (snippets/landing-raeume.liquid,
   landing-bedarf.liquid, landing-consultation.liquid). Ohne JavaScript bleibt der
   erste Raum sichtbar, der Rechner zeigt Striche und das Formular funktioniert. */
(() => {
  function track(eventName, element) {
    if (!window.FennextTracking) return;
    window.FennextTracking.push(
      eventName,
      element.getAttribute('data-content-handle'),
      element.getAttribute('data-track-label') || '',
      'landing',
    );
  }

  // Raum-Tabs nach dem WAI-ARIA-Tabs-Muster: Pfeiltasten, Pos1, Ende, roving tabindex.
  function initRooms(root) {
    var tabs = Array.from(root.querySelectorAll('[role="tab"]'));
    if (tabs.length === 0) return;

    function select(tab, setFocus) {
      tabs.forEach((other) => {
        var active = other === tab;
        other.setAttribute('aria-selected', active ? 'true' : 'false');
        other.tabIndex = active ? 0 : -1;
        var panel = document.getElementById(other.getAttribute('aria-controls'));
        if (panel) panel.hidden = !active;
      });
      if (setFocus) tab.focus();
    }

    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => select(tab, false));
      tab.addEventListener('keydown', (event) => {
        var next = null;
        if (event.key === 'ArrowRight') next = tabs[(index + 1) % tabs.length];
        if (event.key === 'ArrowLeft') next = tabs[(index - 1 + tabs.length) % tabs.length];
        if (event.key === 'Home') next = tabs[0];
        if (event.key === 'End') next = tabs[tabs.length - 1];
        if (!next) return;
        event.preventDefault();
        select(next, true);
      });
    });
  }

  // Ausstattungsbeispiel: gleiche Formel wie der Akustik-Check (sections/rechner.liquid).
  function initNeed(box) {
    var area = box.querySelector('[data-lp-need-area]');
    var areaOut = box.querySelector('[data-lp-need-area-out]');
    if (!area) return;
    var num = (name) => Number.parseFloat(box.getAttribute(name)) || 0;
    var faktor = num('data-faktor') || 1;
    var mwst = num('data-mwst');
    var steuerInklusive = box.getAttribute('data-steuer-inklusive') === 'true';
    var wandAnteil = num('data-wand-anteil') / 100;
    var wandM2 = num('data-wand-m2');
    var wandPreis = num('data-wand-preis');
    var deckeM2 = num('data-decke-m2');
    var deckePreis = num('data-decke-preis');
    var waehrung = box.getAttribute('data-waehrung') || 'EUR';
    var benutzt = false;
    var letzter = { flaeche: 0, bedarf: 0 };

    var zahl = (wert, stellen) =>
      wert.toLocaleString(document.documentElement.lang || 'de', {
        minimumFractionDigits: stellen,
        maximumFractionDigits: stellen,
      });
    var geld = (cent) =>
      (Math.round(cent / 100 / 50) * 50).toLocaleString(document.documentElement.lang || 'de', {
        style: 'currency',
        currency: waehrung,
        maximumFractionDigits: 0,
      });
    var setze = (selektor, text) => {
      var element = box.querySelector(selektor);
      if (element) element.textContent = text;
    };

    function rechne() {
      var flaeche = Number(area.value);
      var gewaehlt = box.querySelector('input[name="lp-need-grade"]:checked');
      var grad = gewaehlt ? Number(gewaehlt.value) : 0.225;
      var bedarf = flaeche * grad * faktor;
      var wand = wandM2 > 0 ? bedarf * wandAnteil : 0;
      var decke = deckeM2 > 0 ? bedarf - wand : 0;
      if (wandM2 === 0) decke = bedarf;
      if (deckeM2 === 0) wand = bedarf;
      var wandStueck = wandM2 > 0 ? Math.ceil(wand / wandM2) : 0;
      var deckeStueck = deckeM2 > 0 ? Math.ceil(decke / deckeM2) : 0;
      var brutto = wandStueck * wandPreis + deckeStueck * deckePreis;
      var netto = brutto;
      if (steuerInklusive && mwst > 0) netto = brutto / (1 + mwst / 100);
      else if (mwst > 0) brutto = netto * (1 + mwst / 100);

      if (areaOut) areaOut.textContent = `${flaeche} m²`;
      setze('[data-lp-need-total]', `${zahl(bedarf, 1)} m²`);
      setze('[data-lp-need-wall]', `${zahl(wand, 1)} m² ≈ ${wandStueck}`);
      setze('[data-lp-need-ceiling]', `${zahl(decke, 1)} m² ≈ ${deckeStueck}`);
      // Spanne statt Einzelbetrag: Der Richtwert ist keine Zusage.
      setze('[data-lp-need-net]', `${geld(netto * 0.9)} – ${geld(netto * 1.15)}`);
      setze('[data-lp-need-gross]', `${geld(brutto * 0.9)} – ${geld(brutto * 1.15)}`);
      letzter = { flaeche: flaeche, bedarf: bedarf };
    }

    function ersteNutzung() {
      if (benutzt) return;
      benutzt = true;
      track('landing_calc_use', box);
    }

    area.addEventListener('input', () => {
      ersteNutzung();
      rechne();
    });
    box.querySelectorAll('input[name="lp-need-grade"]').forEach((radio) => {
      radio.addEventListener('change', () => {
        ersteNutzung();
        rechne();
      });
    });
    var cta = box.querySelector('[data-lp-need-cta]');
    if (cta) {
      cta.addEventListener('click', () => {
        vorbelegen(
          `Richtwert aus dem Ausstattungsbeispiel: ${letzter.flaeche} m² Raum, ca. ${zahl(letzter.bedarf, 1)} m² Absorberfläche.`,
          letzter.flaeche,
        );
      });
    }
    rechne();
  }

  // Formular auf derselben Seite vorbelegen: Einsatzbereich, Nachricht, Fläche.
  function vorbelegen(text, flaeche) {
    var bereich = document.querySelector('[data-lp-consultation]');
    if (!bereich) return;
    var nachricht = bereich.querySelector('textarea[name="contact[body]"]');
    var feld = bereich.querySelector('input[name="contact[Ungefähre Fläche in m²]"]');
    var details = feld ? feld.closest('details') : null;
    if (nachricht && text && nachricht.value.indexOf(text) === -1) {
      nachricht.value = nachricht.value ? `${nachricht.value}\n${text}` : text;
    }
    if (flaeche && feld) {
      feld.value = flaeche;
      if (details) details.open = true;
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-lp-rooms]').forEach(initRooms);
    document.querySelectorAll('[data-lp-need]').forEach(initNeed);

    var beratung = document.querySelector('[data-lp-consultation]');
    var gebiet = beratung ? beratung.getAttribute('data-lp-bereich') : '';
    var auswahl = beratung
      ? beratung.querySelector('select[name="contact[Einsatzbereich]"]')
      : null;
    if (beratung) {
      if (gebiet && auswahl && Array.from(auswahl.options).some((o) => o.value === gebiet)) {
        auswahl.value = gebiet;
      }
    }

    document.addEventListener('click', (event) => {
      var ausloeser = event.target.closest('[data-lp-prefill]');
      if (ausloeser) vorbelegen(ausloeser.getAttribute('data-lp-prefill'));
    });
  });
})();
